export const companionWeekCalendarLayout = {
  rail:
    "grid auto-cols-[minmax(260px,1fr)] grid-flow-col gap-3 overflow-x-auto pb-2",
  card:
    "flex min-h-[300px] min-w-[260px] flex-col rounded-md border border-border-light bg-warm-bg p-3",
} as const;
